import {Dict, list} from "../core/Reflection";
import {ICutoutData, ICutoutPolygonData, ICutoutProvider, ICutoutSpriteData} from "./ICutoutData";

export class CutoutData implements ICutoutData, ICutoutProvider {

    public readonly cutouts = list(() => new CutoutPolygonData());
    private readonly factory: (cutoutData: ICutoutData) => void;
    private polygons: Dict<string, number[][]> = {};
    private initialized = false;

    constructor(factory: (cutoutData: ICutoutData) => void) {
        this.factory = factory;
    }

    public getPolygons(textureName: string): number[][] | undefined {
        if (!this.initialized) {
            this.initialize();
        }
        return this.polygons[textureName.replace(/\.\w*$/, "")];
    }

    public initialize() {
        if (!this.initialized) {
            this.initialized = true;
            this.factory(this);

            for (const cutout of this.cutouts) {
                this.polygons[cutout.sprite.textureName.replace(/\.\w*$/, "")] = cutout.polygons;
            }
        }
    }

    public clearPolygons() {
        this.cutouts.length = 0;
        this.polygons = {};
        this.initialized = false;
    }
}

class CutoutSpriteData implements ICutoutSpriteData {

    public x: number = 0;
    public y: number = 0;
    public height: number = 0;
    public width: number = 0;
    public textureName: string = "";

    public setLayoutTexture(name: string, anchorX: number, anchorY: number): void {
        this.textureName = name;
    }
}

class CutoutPolygonData implements ICutoutPolygonData {
    public x: number = 0;
    public y: number = 0;
    public readonly polygons: number[][] = list(() => []);
    public readonly sprite = new CutoutSpriteData();
    public readonly sprites = [];
}
